// must be kept in sync with ELIGIBLE_TEAM_CLASSES in backend/core/models.py
export const ELIGIBLE_TEAM_CLASSES = ['Swedish', 'Nordic', 'Eligible']

// How the competition classes are named in the rules.
export function eligibilityLabel (eligibilityClass) {
    return {
        Swedish: 'Sweden class',
        Nordic: 'Nordic class',
        Eligible: 'Official',
        Open: 'Outside the official ranking',
    }[eligibilityClass] || eligibilityClass
}

export function dateToISO (d) {
    function pad (number) {
        if (number < 10) {
            return '0' + number
        }
        return number
    }

    return d.getFullYear() +
        '-' + pad(d.getMonth() + 1) +
        '-' + pad(d.getDate()) +
        ' ' + pad(d.getHours()) +
        ':' + pad(d.getMinutes()) +
        ':' + pad(d.getSeconds())
}
